<template>
  <div class="container pb-5">
    <div class="text-center mx-auto" style="max-width: 600px;">

      <!-- Step 1: State Gate -->
      <form v-if="step === 1" @submit.prevent="submitStateGate" class="p-4">
        <h1 class="main-headline mb-4 text-uppercase">{{ $t('Gate.Headline') }}</h1>

        <div class="mb-4 text-start col-md-8 mx-auto">
          <label class="form-label fw-bold text-uppercase">{{ $t('Gate.StateLabel') }}*</label>
          <select v-model="state" class="form-select custom-state-select" required>
            <option value="" disabled>{{ $t('Gate.SelectPlaceholder') }}</option>
            <option v-for="s in allStates" :key="s.value" :value="s.value">{{ s.text }}</option>
          </select>
        </div>

        <div v-if="errorMsg" class="text-danger mb-3 fw-bold">
          {{ errorMsg }}
        </div>

        <button type="submit" class="btn btn-primary-slanted mt-2 px-5 py-3">
          <span class="btn-text-unskew">{{ $t('Gate.SubmitBtn') }}</span>
        </button>
      </form>

      <!-- Step 2: Fail Gate -->
      <div v-else-if="step === 2" class="text-center p-4 p-md-5">
        <h2 class="h3-headline mb-4">{{ $t('Gate.IneligibleTitle') }}</h2>
        <p class="mb-5 hero-description" v-html="$t('Gate.IneligibleDesc')"></p>
        <div>
          <button @click="resetGate" class="btn btn-primary-slanted">
            <span class="btn-text-unskew">{{ $t('Gate.TryAgainBtn') }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Gate',
  data() {
    return {
      step: 1,
      state: '',
      errorMsg: '',
      allStates: [
        { text: 'IL — Illinois', value: 'IL' },
        { text: 'IN — Indiana', value: 'IN' },
        { text: 'KY — Kentucky', value: 'KY' },
        { text: 'MI — Michigan', value: 'MI' },
        { text: 'MO — Missouri', value: 'MO' },
        { text: 'OH — Ohio', value: 'OH' },
        { text: 'WV — West Virginia', value: 'WV' },
        // { text: 'Alabama', value: 'AL' },
        // { text: 'Alaska', value: 'AK' },
        // { text: 'Arizona', value: 'AZ' },
        // { text: 'Arkansas', value: 'AR' },
        // { text: 'California', value: 'CA' },
        // { text: 'Colorado', value: 'CO' },
        // { text: 'Connecticut', value: 'CT' },
        // { text: 'Delaware', value: 'DE' },
        // { text: 'District Of Columbia', value: 'DC' },
        // { text: 'Florida', value: 'FL' },
        // { text: 'Georgia', value: 'GA' },
        // { text: 'Hawaii', value: 'HI' },
        // { text: 'Idaho', value: 'ID' },
        // { text: 'Iowa', value: 'IA' },
        // { text: 'Kansas', value: 'KS' },
        // { text: 'Louisiana', value: 'LA' },
        // { text: 'Maine', value: 'ME' },
        // { text: 'Maryland', value: 'MD' },
        // { text: 'Massachusetts', value: 'MA' },
        // { text: 'Minnesota', value: 'MN' },
        // { text: 'Mississippi', value: 'MS' },
        // { text: 'Montana', value: 'MT' },
        // { text: 'Nebraska', value: 'NE' },
        // { text: 'Nevada', value: 'NV' },
        // { text: 'New Hampshire', value: 'NH' },
        // { text: 'New Jersey', value: 'NJ' },
        // { text: 'New Mexico', value: 'NM' },
        // { text: 'New York', value: 'NY' },
        // { text: 'North Carolina', value: 'NC' },
        // { text: 'North Dakota', value: 'ND' },
        // { text: 'Oklahoma', value: 'OK' },
        // { text: 'Oregon', value: 'OR' },
        // { text: 'Pennsylvania', value: 'PA' },
        // { text: 'Rhode Island', value: 'RI' },
        // { text: 'South Carolina', value: 'SC' },
        // { text: 'South Dakota', value: 'SD' },
        // { text: 'Tennessee', value: 'TN' },
        // { text: 'Texas', value: 'TX' },
        // { text: 'Utah', value: 'UT' },
        // { text: 'Vermont', value: 'VT' },
        // { text: 'Virginia', value: 'VA' },
        // { text: 'Washington', value: 'WA' },
        // { text: 'Wisconsin', value: 'WI' },
        // { text: 'Wyoming', value: 'WY' }
      ],
      eligibleStates: ['OH', 'IN', 'KY', 'MI', 'IL', 'MO', 'WV']
    };
  },
  methods: {
    submitStateGate() {
      this.errorMsg = '';

      if (!this.state) {
        this.errorMsg = 'Please select your state.';
        return;
      }

      if (!this.eligibleStates.includes(this.state)) {
        this.step = 2; // Fail Gate
        return;
      }

      // Validation passed - Store standard Snipp values so they populate in Registration
      sessionStorage.setItem('gatePassed', 'true');
      sessionStorage.setItem('State', this.state);
      sessionStorage.setItem('selectedState', this.state);

      this.$router.push({ name: 'Home' });
    },
    resetGate() {
      this.step = 1;
      this.state = '';
      this.errorMsg = '';
    }
  }
};
</script>

<style scoped>
.custom-state-select {
  height: 50px;
  font-family: "Sofia Sans", sans-serif;
  font-size: 1.1rem;
  color: #333333;
  border: 1.5px solid #d1d5db;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  width: 100%;
}

.custom-state-select:focus {
  border-color: #1998d5;
  box-shadow: 0 0 0 3px rgba(25, 152, 213, 0.2);
}

.form-label {
  color: #8993a4;
  font-family: "Sofia Sans", sans-serif;
  font-weight: 800;
}
</style>
